export enum EBarElementProperty {
  Background = "background",
  Color = "color"
}